import getLogger from "../../logger/index";
import config from "lib/config";
import { get } from "util/apiRequest";
import { getDynamicRoute } from "util/createProfileIdPath";
const log = getLogger("PARSER_REQUEST");
export const PARSER_REQUEST = "PARSER_REQUEST";
export const PARSER_SUCCESS = "PARSER_SUCCESS";
export const PARSER_FAILURE = "PARSER_FAILURE";
export const REQUESTING = "Requesting";
export const SUCCESS = "Success";
export const ERROR = "Error";
export const SET_PARSER_DATA = "SET_PARSER_DATA";
export function parserRequest() {
  return {
    type: PARSER_REQUEST,
    status: REQUESTING,
  };
}
export function parserSuccess(locations) {
  return {
    type: PARSER_SUCCESS,
    status: SUCCESS,
    locations,
  };
}
export function parserFailure(error) {
  return {
    type: PARSER_FAILURE,
    status: ERROR,
    error,
  };
}
export function setParserData(parserData) {
  return {
    type: SET_PARSER_DATA,
    parserData,
  };
}
export function parser(locationText, review = false) {
  return async (dispatch) => {
    dispatch(parserRequest());
    try {
      let url = `${
        config.GATEWAY_URL
      }/${getDynamicRoute()}/api/v3/suggest?locationText=${locationText}`;
      url = review ? `${url}&review=true` : url;
      const result = await get(url);

      const resultJson = result;

      if (resultJson.error) {
        throw new Error(resultJson.error);
      }
      if (review) {
        return dispatch(parserSuccess(resultJson.data));
      } else {
        return dispatch(parserSuccess(resultJson.data.autocomplete));
      }
    } catch (e) {
      log.error(
        "Error while fetching PARSER_REQUEST data for the Location Text : " + locationText,
        e,
      );
      dispatch(parserFailure(e.message));
    }
  };
}
